import React, { useState } from "react";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import { formatNumericparseFloatInput, processAndValidateEmail, validateGstNumber, validateValue } from "../Reusable_Components/ReusableFunctions";
import { FaSearch } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import { base_url } from "../../utilities";
import axios from "axios";
import AlertPopUp from "../Reusable_Components/Alert";

export const RegistrationMultitenant = () => {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate("/community-login");
    };

    const handleHome = () => {
        navigate("/home");
    };


    const [username, setUsername] = useState('')
    const [usernameError, setUsernameError] = useState("")
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [phoneNumberError, setPhoneNumberError] = useState(false)
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [companyName, setCompanyName] = useState('')
    // const [companyNameError, setCompanyNameError] = useState("")
    const [gstNumber, setGstNumber] = useState('')
    const [gstNumberError, setGstNumberError] = useState(false)
    const [agreedToTerms, setAgreedToTerms] = useState(false)
    const [isValidGstNumber, setIsValidGstNumber] = useState(true);
    const [isContractNameValid, setIsContractNameValid] = useState(true);
    const [companyNameValid, setCompanyNameValid] = useState(true);

    const handleContractNameChange = (event) => {
        let value = event.target.value;
        value = value.replace(/[^a-zA-Z0-9./\\\-_]+/g, '');
        value = value.trim();
        if (validateValue(value.charAt(0))) {
            setUsername(value);
            const lengthValid = value.length >= 3 && value.length <= 200;
            setIsContractNameValid(lengthValid);
            if(value.length === 0){
                setIsContractNameValid(true);
            }
        } else {
            event.target.value = username;
        }
    };

    const handleCompanyNameChange = (event) => {
        let value = event.target.value;
        value = value.replace(/[^a-zA-Z0-9./\\\-_]+/g, '');
        value = value.trim();
        if (validateValue(value.charAt(0))) {
            setCompanyName(value);
            const lengthValid = value.length >= 3 && value.length <= 200;
            setCompanyNameValid(lengthValid);
        } else {
            event.target.value = username;
        }
    };

    const [loader, setLoader] = useState(false)
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])

    const postOrganisationDeatils = () => {
        setLoader(true)
        const body = {
            user_name: username,
            phone_number: phoneNumber,
            email: email,
            first_name: firstName,
            last_name: lastName,
            company_name: companyName,
            gst_number: gstNumber,
        }
        axios.post(`${base_url}subscription/register`, body)
            .then((response) => {
                console.log("response", response)
                const data = response.data?.data;
                const orgId = data?.org_id;
                // setOrgId(orgId)
                // localStorage.setItem("org_id", orgId)
                setLoader(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue('You Have Successfully Registered, please check your email to set your password and login')
                setAlertButtons([
                    {
                        name: 'Login', action: () => {
                            setAlertShow(false)
                            setAlertValue('')
                            navigate("/community-login")
                        }
                    },
                ])

            })
            .catch((error) => {
                console.log("error", error)
                setLoader(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data?.message)
                setAlertButtons([
                    {
                        name: 'Close', action: () => {
                            setAlertShow(false)
                            setAlertValue('')
                        }
                    },
                ])
            })
    }



   

  

    const handleGstNumberChange = (e) => {
        const input = e.target.value;
        const { isValid, uppercasedInput } = validateGstNumber(input);
        setGstNumber(uppercasedInput);
        setIsValidGstNumber(isValid);
    };

    const [gstLoader, setGstLoader] = useState(false)
    const [errorValue, setErrorValue] = useState(false)

    const GstLoader = () => {
        return <Spinner style={{ height: "18px", width: "18px" }} animation="border" variant="light" />
    }


    const handleGstClick = (gstId) => {
        setGstLoader(true)
        axios.get(base_url + "gstPortal/verifyGstin?gst_number=" + gstId)
            .then((response) => {
                const details = response.data.data
                // setCompanyName(details?.company_name)
                // setPanName(details?.pan_number)
                // setRegisteredStateProvince(details?.registered_address?.state)
                // setRegisteredPostalCode(details?.registered_address?.postal_code)
                // setRegisteredStreetAddress(details?.registered_address?.door_number + details?.registered_address?.street_address_1)
                // setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                // setRegisteredCity(details?.registered_address?.city)
                // setRegisteredCountry(details?.registered_address?.country)

                // setBillingStateProvince(details?.registered_address?.state);
                // setBillingCountry(details?.registered_address?.country);
                // // setBillingPostalCode(details?.registered_address?.postal_code);
                // setShippingStateProvince(details?.registered_address?.state);
                // setShippingCountry(details?.registered_address?.country);
                // // setShippingPostalCode(details?.registered_address?.postal_code);
                // setBusinessName(details?.company_name)
                // // setBusinessHcnNumber()
                // setBusinessAddress(details?.registered_address?.door_number + details?.registered_address?.street_address_1)
                // setBusinessAddress2(details?.registered_address?.street_address_2)
                // setBusinessCity(details?.registered_address?.city)
                // setBusinessState(details?.registered_address?.state)
                // setBusinessCountry(details?.registered_address?.country)
                // setBusinessZipcode(details?.registered_address?.postal_code)
                setCompanyName(details?.company_name)
                setGstLoader(false)

            })
            .catch((error) => {
                const errorDetails = JSON.parse(error.response.data.error_logs.status_desc);
                const errorMessage = errorDetails[0].ErrorMessage
                // setErrorValue(errorMessage);
                // setAlertShow(true);
                // setAlertType('error');
                // setAlertMessage('Error');
                // setAlertValue(errorMessage);
                // setAlertButtons([
                //     {
                //         name: 'Close',
                //         action: () => {
                //             setAlertShow(false);
                //         }
                //     }
                // ]);
                // setIsLoading(false);
                setGstLoader(false);
            });
    }

    return (
        <div className="registration-page">
            <AlertPopUp alertShow={alertShow} alertType={alertType}
                alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            <div className="nav-bar">
                <div className="logo-img">
                    <a href="/home">
                        <img src="./images/icons/PortOSlogo.svg" alt="PortOS logo" style={{ cursor: "pointer" }} />
                    </a>
                </div>
                <div className="nav-links" style={{ justifyContent: "space-between", gap: "40px" }}>
                    <div className="nav-links">
                        <div className="nav-item"><a href="/home" style={{ textDecoration: "none", color: "black" }}>Home</a></div>
                    </div>
                    <div className="log-button" onClick={handleGetStarted}>
                        <div className="text-wrapper-3">Log in</div>
                    </div>
                </div>
                <div className="nav-right">
                    <div className="nav-item" onClick={handleHome}>Home</div>
                    <div className="moblielogin-button" onClick={handleGetStarted}>
                        <span>Login</span>
                    </div>
                </div>
            </div>
            <div className="content-container">
                <div className="left-half">
                    <img src="./images/icons/efficiency1.jpg" alt="registration" />
                </div>
                <div className="right-half">
                    <div className="registration-form">
                        <h2>Register your Organization</h2>
                        <div className="form-container">
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="FirstName">First Name</label>
                                    <input
                                        type="text"
                                        id="FirstName"
                                        name="firstName"
                                        className="form-control"
                                        value={firstName}
                                        onChange={e => {
                                            const input = e.target.value;
                                            // accept only alphabets 
                                            const formattedInput = input.replace(/[^a-zA-Z]/g, '');
                                            setFirstName(formattedInput);
                                        }
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="LastName">Last Name</label>
                                    <input
                                        type="text"
                                        id="LastName"
                                        name="lastName"
                                        className="form-control"
                                        value={lastName}
                                        onChange={e => {
                                            const input = e.target.value;
                                            // accept only alphabets 
                                            const formattedInput = input.replace(/[^a-zA-Z]/g, '');
                                            setLastName(formattedInput);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>User Name</label>
                            <input
                                type="text"
                                name="userName"
                                className="form-control"
                                value={username}
                                onChange={handleContractNameChange}
                            />
                            {!isContractNameValid && <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}

                        </div>
                        <div className="form-group">
                            <label>Phone Number</label>
                            <input
                                type="tel"
                                name="phoneNumber"
                                className="form-control"
                                value={phoneNumber}
                                onChange={e => {
                                    // setIsPhoneNumberValid(isValidPhone);
                                    const input = e.target.value;
                                    const formattedInput = input.replace(/[^\d+]/g, '');
                                    let trimmedInput = formattedInput.slice(0, 15);
                                    setPhoneNumber(trimmedInput);
                                    setPhoneNumberError(trimmedInput.length < 10 ? true : false);
                                    if(trimmedInput.length === 0){
                                        setPhoneNumberError(false);
                                    }
                                }}
                            />
                            {phoneNumberError &&
                                <span className='input-error-text'>Must minimum of 10 and maximum of 15 digits</span>}
                        </div>
                        <div className="form-group">
                            <label>Email ID</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                value={email}
                                onChange={(e => {
                                    const input = e.target.value;
                                    const { processedInput, isValid } = processAndValidateEmail(input);
                                    setEmail(input);
                                    setEmailError(!isValid);

                                })}
                            />
                            {emailError && <span className="error">Please enter a valid email address</span>}
                        </div>
                        <div className="form-container">
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="companyName">Company Name</label>
                                    <input
                                        type="text"
                                        id="companyName"
                                        name="companyName"
                                        className="form-control"
                                        value={companyName}
                                        onChange={handleCompanyNameChange}
                                    />
                                    {!companyNameValid && <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="gstNumber">GST Number</label>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <input
                                            type="text"
                                            id="gstNumber"
                                            name="gstNumber"
                                            className="form-control"
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                            }}
                                            value={gstNumber}
                                            onChange={handleGstNumberChange}
                                        />
                                    </div>
                                    {!isValidGstNumber && <span className="input-error-text">Invalid GST number</span>}
                                </div>
                            </div>
                        </div>

                        <div className="terms-container">
                            <input
                                type="checkbox"
                                id="terms"
                                name="agreedToTerms"
                                checked={agreedToTerms}
                                onChange={e => {
                                    setAgreedToTerms(e.target.checked);
                                }}
                            />
                            <label htmlFor="terms">I agree to the <span style={{ textDecoration: 'underline' }}>Privacy Policy</span> and <span style={{ textDecoration: 'underline' }}> Terms & Conditions</span></label>
                        </div>
                        <button
                            disabled={
                                !username || !firstName || !lastName || !phoneNumber || !email || !agreedToTerms ||
                                phoneNumberError || emailError || !companyNameValid || !isValidGstNumber || !isContractNameValid
                            }

                            style={{
                                opacity: !username || !firstName || !lastName || !phoneNumber || !email || !agreedToTerms ||
                                    !companyNameValid ||
                                    phoneNumberError || emailError || !isValidGstNumber || !isContractNameValid
                                    ? 0.5 : 1,
                                pointerEvents: !username || !firstName || !lastName || !phoneNumber || !email || !agreedToTerms ||
                                    phoneNumberError || emailError ? 'none' : 'auto'
                            }}
                            onClick={() => postOrganisationDeatils()} className="register-button mt-1">Register Now</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

